import React, { useEffect } from 'react';
import { scrollToHashOnLoad, handleAnchorClick } from '../../utils/scrollUtils';

export default function ScrollTest() {
  useEffect(() => {
    // Handle scrolling to section if URL has hash on load
    scrollToHashOnLoad(80);
  }, []);

  const handleNavClick = (e) => {
    const href = e.target.getAttribute('href');
    handleAnchorClick(e, href, 80, 0);
  };

  return (
    <div className="min-h-screen bg-white">
      <nav className="sticky top-0 bg-white shadow-md z-50 py-4">
        <div className="container mx-auto px-4">
          <div className="flex justify-center space-x-8">
            <a 
              href="#section1" 
              onClick={handleNavClick} 
              className="px-4 py-2 rounded-md bg-blue-500 text-white"
            >
              Section 1
            </a>
            <a 
              href="#section2" 
              onClick={handleNavClick} 
              className="px-4 py-2 rounded-md bg-green-500 text-white"
            >
              Section 2
            </a>
            <a 
              href="#section3" 
              onClick={handleNavClick} 
              className="px-4 py-2 rounded-md bg-purple-500 text-white"
            >
              Section 3
            </a>
          </div>
        </div>
      </nav>
      
      <section 
        id="section1" 
        className="min-h-screen bg-blue-100 flex items-center justify-center"
      >
        <div className="text-center">
          <h2 className="text-4xl font-bold mb-4">Section 1</h2>
          <p className="text-xl">This is section 1 content</p>
        </div>
      </section>
      
      <section 
        id="section2" 
        className="min-h-screen bg-green-100 flex items-center justify-center"
      >
        <div className="text-center">
          <h2 className="text-4xl font-bold mb-4">Section 2</h2>
          <p className="text-xl">This is section 2 content</p>
        </div>
      </section>
      
      <section 
        id="section3" 
        className="min-h-screen bg-purple-100 flex items-center justify-center"
      >
        <div className="text-center">
          <h2 className="text-4xl font-bold mb-4">Section 3</h2>
          <p className="text-xl">This is section 3 content</p>
        </div>
      </section>
    </div>
  );
} 